'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Actions


// Components


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = require('lodash/fp');

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _point = require('../../../common/documentOrder/geometry/point');

var _lineUtil = require('./lineUtil');

var _point2 = require('../../../common/maths/geometry/point');

var pointsLib = _interopRequireWildcard(_point2);

var _lineSelector = require('./lineSelector');

var _elementActions = require('../elementActions');

var _LinePresentationalWrapper = require('./LinePresentationalWrapper');

var _LinePresentationalWrapper2 = _interopRequireDefault(_LinePresentationalWrapper);

var _elementConnectionsSourceDecorator = require('../../components/connections/components/elementConnectionsSourceDecorator');

var _elementConnectionsSourceDecorator2 = _interopRequireDefault(_elementConnectionsSourceDecorator);

var _lineConstants = require('../../../common/lines/lineConstants');

var _boardConstants = require('../../../common/boards/boardConstants');

var _elementConstants = require('../../../common/elements/elementConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchMoveAndUpdateElement: function dispatchMoveAndUpdateElement(_ref) {
            var id = _ref.id,
                changes = _ref.changes,
                location = _ref.location,
                transactionId = _ref.transactionId;
            return dispatch((0, _elementActions.atomicMoveAndUpdate)({ id: id, changes: changes, location: location, transactionId: transactionId }));
        }
    };
};

var connectionSourceCollect = {
    getConnectionTargetIds: function getConnectionTargetIds(_ref2) {
        var element = _ref2.element;
        return (0, _fp.compact)([element.getIn(['content', 'start', 'elementId']), element.getIn(['content', 'end', 'elementId'])]);
    }
};

var connectionSourceSpec = {
    handleConnectedElementMove: function handleConnectedElementMove(props, action, move) {
        var element = props.element,
            updateLineEdge = props.updateLineEdge,
            gridSize = props.gridSize;


        var elementParentId = element.getIn(['location', 'parentId']);
        var droppedParentId = move.location.parentId;
        var droppedSection = move.location.section;
        if (elementParentId === droppedParentId && droppedSection === _boardConstants.BOARD_SECTIONS.CANVAS) return;

        var movedElementId = move.id;

        // Find the edge that was connected and remove its connection
        var modifiedEdgeName = element.getIn(['content', 'start', 'elementId']) === movedElementId ? _lineConstants.LINE_EDGE.start : _lineConstants.LINE_EDGE.end;

        var scaleToGridUnits = pointsLib.scale(1 / gridSize);
        var edgesBeforeMove = props.getCachedEdges();

        var previousEdgePosition = edgesBeforeMove[modifiedEdgeName];
        var previousEdgeGridPosition = scaleToGridUnits(previousEdgePosition);

        var modifiedEdge = element.getIn(['content', modifiedEdgeName]);
        var newPosition = modifiedEdge.set('x', previousEdgeGridPosition.x).set('y', previousEdgeGridPosition.y).set('snapped', false).remove('elementId').toJS();

        updateLineEdge({ edge: modifiedEdgeName, newPosition: newPosition, transactionId: action.transactionId });
    },
    handleConnectionSourceMove: function handleConnectionSourceMove(props, action, move) {
        var dispatchUpdateElement = props.dispatchUpdateElement,
            gridSize = props.gridSize;

        // TODO This feels a bit hacky, would want to find a cleaner way of handling this

        var disconnectStart = true;
        var disconnectEnd = true;
        if (action.type === _elementConstants.ELEMENT_MOVE_MULTI) {
            var movedElementIds = action.moves.map(function (elementMove) {
                return elementMove.id;
            });

            var startConnectedElementId = (0, _lineSelector.getStartConnectedElementId)(null, props);
            var endConnectedElementId = (0, _lineSelector.getEndConnectedElementId)(null, props);

            disconnectStart = !(0, _fp.includes)(startConnectedElementId, movedElementIds);
            disconnectEnd = !(0, _fp.includes)(endConnectedElementId, movedElementIds);
        }

        var scaleToGridUnits = pointsLib.scale(1 / gridSize);
        var edgesBeforeMove = props.getCachedEdges();
        var changes = {};
        var shouldDispatchUpdate = false;

        if (disconnectStart) {
            shouldDispatchUpdate = true;
            changes.start = _extends({}, scaleToGridUnits(edgesBeforeMove.start), {
                snapped: false
            });
        }

        if (disconnectEnd) {
            shouldDispatchUpdate = true;
            changes.end = _extends({}, scaleToGridUnits(edgesBeforeMove.end), {
                snapped: false
            });
        }

        shouldDispatchUpdate && dispatchUpdateElement({ id: move.id, changes: changes, transactionId: action.transactionId });
    }
};

var LineConnectionSource = function LineConnectionSource(props) {
    return _react2.default.createElement(_LinePresentationalWrapper2.default, props);
};

LineConnectionSource = (0, _elementConnectionsSourceDecorator2.default)(connectionSourceSpec, connectionSourceCollect)(LineConnectionSource);

var LineContainer = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(LineContainer, _React$Component);

    function LineContainer(props) {
        _classCallCheck(this, LineContainer);

        var _this = _possibleConstructorReturn(this, (LineContainer.__proto__ || Object.getPrototypeOf(LineContainer)).call(this, props));

        _this.getCachedEdges = function () {
            return {
                start: _this.start,
                end: _this.end
            };
        };

        _this.cacheEdges = function (_ref3) {
            var start = _ref3.start,
                end = _ref3.end;

            _this.start = start;
            _this.end = end;
        };

        _this.updateLineControlPoint = function (_ref4) {
            var control = _ref4.control;
            var _this$props = _this.props,
                dispatchUpdateElement = _this$props.dispatchUpdateElement,
                element = _this$props.element;


            dispatchUpdateElement({
                id: element.get('id'),
                changes: { control: control }
            });
        };

        _this.updateLineEdge = function (_ref5) {
            var edge = _ref5.edge,
                newPosition = _ref5.newPosition,
                transactionId = _ref5.transactionId;
            var _this$props2 = _this.props,
                element = _this$props2.element,
                dispatchMoveAndUpdateElement = _this$props2.dispatchMoveAndUpdateElement;

            var id = element.get('id');

            var changes = _defineProperty({
                start: element.getIn(['content', 'start']).toJS(),
                end: element.getIn(['content', 'end']).toJS()
            }, edge, newPosition);

            // Ensure the line is at least a size of MIN_LINE_LENGTH
            var newLineDist = (0, _lineUtil.getLineDistance)(changes);
            if (newLineDist < _lineConstants.MIN_LINE_LENGTH) {
                var distanceToIncreaseBy = _lineConstants.MIN_LINE_LENGTH - newLineDist;

                // Need to extend the line
                var mobileEdge = edge === _lineConstants.LINE_EDGE.start ? changes.start : changes.end;
                var staticEdge = edge === _lineConstants.LINE_EDGE.start ? changes.end : changes.start;

                var movedEdge = (0, _lineUtil.enlargeLine)(mobileEdge, staticEdge, distanceToIncreaseBy);
                changes[edge] = _extends({}, changes[edge], movedEdge);
            }

            var endpoints = (0, _fp.values)(changes);
            var translation = (0, _point.getTopLeftBoundaryPoint)(endpoints);

            var initialLocation = element.get('location').toJS();

            // Translate the actual element position down
            var updatedLocation = _extends({}, initialLocation, {
                position: (0, _point2.translate)(translation, initialLocation.position)
            });

            // Reverse the translation on the endpoints
            changes.start = (0, _point2.reverseTranslate)(translation, changes.start);
            changes.end = (0, _point2.reverseTranslate)(translation, changes.end);

            dispatchMoveAndUpdateElement({ id: id, changes: changes, location: updatedLocation, transactionId: transactionId });
        };

        _this.toggleLineVisibility = function () {
            _this.setState({
                invisible: !_this.state.invisible
            });
        };

        _this.state = { invisible: false };
        return _this;
    }

    _createClass(LineContainer, [{
        key: 'render',
        value: function render() {
            var invisible = this.state.invisible;

            return _react2.default.createElement(LineConnectionSource, _extends({ className: (0, _classnames2.default)({ invisible: invisible }), updateLineEdge: this.updateLineEdge,
                updateLineControlPoint: this.updateLineControlPoint,
                toggleLineVisibility: this.toggleLineVisibility }, this.props, {
                cacheEdges: this.cacheEdges, getCachedEdges: this.getCachedEdges }));
        }
    }]);

    return LineContainer;
}(_react2.default.Component)) || _class);


LineContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    dispatchMoveAndUpdateElement: _propTypes2.default.func,
    dispatchUpdateElement: _propTypes2.default.func
};

exports.default = LineContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/LineContainer.js
// module id = 1990
// module chunks = 0